import { Locale } from '~/models/Locale'
import { Translation } from '../passporter-services/shared/translation'

export class TranslationService extends Translation {
	private static instance: TranslationService
	private i18n

	constructor(i18n?: any) {
		super()
		if (i18n) this.i18n = i18n
	}

	public static getInstance(i18n?: any): TranslationService {
		if (!this.instance) this.instance = new TranslationService(i18n)
		return this.instance
	}

	public getLocale() {
		return this.i18n.locale.value
	}

	public setLocale(locale: string) {
		this.i18n.locale.value = locale
	}

	public translate(key: string): string {
		return this.i18n.t(key)
	}

	public translateWithParams(key: string, params: Record<string, string>): string {
		return this.i18n.t(key, params)
	}

	static availableTranslations() {
		return this.availableLanguagesList().map((locale) => ({
			code: locale,
			file: `${locale}/translations.json`,
		}))
	}

	static availableLanguagesList(): Locale[] {
		return ['ca', 'de', 'en', 'es', 'fr', 'it', 'pt']
	}

	static obtainUserLanguage(): string {
		const languagePath = window.location.pathname.replace(/^\/([^/]+).*/i, '$1')
		const urlLanguage = languagePath !== '/' ? languagePath : undefined
		const userLanguage = navigator.language.split('-')[0]

		return urlLanguage || userLanguage || 'es'
	}
}
